import { SvgIconProps } from '@material-ui/core';
import { FC, forwardRef } from 'react';
import { ReactComponent as PentagonEnergyIconSvg } from './pentagon-energy.svg';
import { ReactComponent as EnergyIconSvg } from './energy.svg';
import { ReactComponent as PentagonLogoIconSvg } from './pentagon-logo.svg';
import { ReactComponent as PentagonTechnologyDeploymentIconSvg } from './pentagon-technology-deployment.svg';
import { ReactComponent as TechnologyDeploymentIconSvg } from './technology-deployment.svg';
import { ReactComponent as PentagonConstructionIconSvg } from './pentagon-construction.svg';
import { ReactComponent as ConstructionIconSvg } from './construction.svg';
import { ReactComponent as PentagonWirelessIconSvg } from './pentagon-wireless.svg';
import { ReactComponent as WirelessIconSvg } from './wireless.svg';
import { ReactComponent as EngineeringIconSvg } from './engineering.svg';
import { ReactComponent as PentagonEngineeringIconSvg } from './pentagon-engineering.svg';
import { ReactComponent as CloseIconSvg } from './close-icon.svg';
import { ReactComponent as MainLogoIconSvg } from './main-logo.svg';
import { ReactComponent as Logo1IconSvg } from './logo1.svg';
import { ReactComponent as Logo2IconSvg } from './logo2.svg';
import { ReactComponent as Logo3IconSvg } from './logo3.svg';
import { ReactComponent as Logo4IconSvg } from './logo4.svg';
import { ReactComponent as Logo5IconSvg } from './logo5.svg';
import { ReactComponent as Logo6IconSvg } from './logo6.svg';
import { ReactComponent as Logo7IconSvg } from './logo7.svg';
import { ReactComponent as Logo8IconSvg } from './logo8.svg';
import { ReactComponent as Logo9IconSvg } from './logo9.svg';
import { ReactComponent as Logo10IconSvg } from './logo10.svg';
import { ReactComponent as Logo11IconSvg } from './logo11.svg';
import { ReactComponent as Logo12IconSvg } from './logo12.svg';
import { ReactComponent as LogoOnHoverIconSvg } from './logoOnHover.svg';

export const PentagonEnergyIcon: FC<SvgIconProps> = forwardRef((props, ref) => <PentagonEnergyIconSvg ref={ref} {...props} />);
export const EnergyIcon: FC<SvgIconProps> = forwardRef((props, ref) => <EnergyIconSvg ref={ref} {...props} />);
export const PentagonLogoIcon: FC<SvgIconProps> = forwardRef((props, ref) => <PentagonLogoIconSvg ref={ref} {...props} />);
export const PentagonTechnologyDeploymentIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <PentagonTechnologyDeploymentIconSvg ref={ref} {...props} />
));
export const TechnologyDeploymentIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <TechnologyDeploymentIconSvg ref={ref} {...props} />
));
export const PentagonConstructionIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <PentagonConstructionIconSvg ref={ref} {...props} />
));
export const ConstructionIcon: FC<SvgIconProps> = forwardRef((props, ref) => <ConstructionIconSvg ref={ref} {...props} />);
export const PentagonWirelessIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <PentagonWirelessIconSvg ref={ref} {...props} />
));
export const WirelessIcon: FC<SvgIconProps> = forwardRef((props, ref) => <WirelessIconSvg ref={ref} {...props} />);
export const EngineeringIcon: FC<SvgIconProps> = forwardRef((props, ref) => <EngineeringIconSvg ref={ref} {...props} />);
export const PentagonEngineeringIcon: FC<SvgIconProps> = forwardRef((props, ref) => (
  <PentagonEngineeringIconSvg ref={ref} {...props} />
));
export const CloseIcon: FC<SvgIconProps> = forwardRef((props, ref) => <CloseIconSvg ref={ref} {...props} />);
export const MainLogoIcon: FC<SvgIconProps> = forwardRef((props, ref) => <MainLogoIconSvg ref={ref} {...props} />);
export const Logo1Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo1IconSvg ref={ref} {...props} />);
export const Logo2Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo2IconSvg ref={ref} {...props} />);
export const Logo3Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo3IconSvg ref={ref} {...props} />);
export const Logo4Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo4IconSvg ref={ref} {...props} />);
export const Logo5Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo5IconSvg ref={ref} {...props} />);
export const Logo6Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo6IconSvg ref={ref} {...props} />);
export const Logo7Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo7IconSvg ref={ref} {...props} />);
export const Logo8Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo8IconSvg ref={ref} {...props} />);
export const Logo9Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo9IconSvg ref={ref} {...props} />);
export const Logo10Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo10IconSvg ref={ref} {...props} />);
export const Logo11Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo11IconSvg ref={ref} {...props} />);
export const Logo12Icon: FC<SvgIconProps> = forwardRef((props, ref) => <Logo12IconSvg ref={ref} {...props} />);
export const LogoOnHoverIcon: FC<SvgIconProps> = forwardRef((props, ref) => <LogoOnHoverIconSvg ref={ref} {...props} />);
